export default {
  payWelfareText: 'Benefici Ricarica',
  blackFridayDiscount: 'Sconto a Tempo Black Friday',
  shareGift: 'Condividi Regalo',
  vipWeeklyWelfare: 'Sconto Settimanale VIP',
  exchangeCoupon: 'Buono',
  firstPayOff: 'Fino al 15% di SCONTO per il Primo Acquisto',
  blackFridayEvent: 'Evento Black Friday',
  limitedTimeOff: 'Sconto del 10% per un Periodo Limitato',
  claimCoupon: 'Rivendica Ora',
  blackFridayTimedCoupon: 'Buono a Tempo Black Friday',
  timeLeft: 'Tempo restante:',
  claimTimeCoupon: 'Rivendica Buono 10% SCONTO Ora!',
  points: 'Punti: ${point}',
  costPointTip: 'Scambia punti per buoni',
  maxPointTip: 'Ogni account può usare fino a 500 punti.',
  discountOff: '10% SCONTO',
  highestDiscount: 'Fino a ${discount} SCONTATI',
  needPoint: 'Richiede ${point} pti',
  changeCurrency: 'Cambia Valuta',
  claim: 'Rivendica',
  claimSucc: 'Rivendicato',
  claimFail: 'Fallito',
  pointNotEnough: 'Pti insufficienti',
  afterClaimPoint: 'Punti rimanenti: ${point}',
  footTips1: 'È possibile utilizzare solo 1 buono per ogni ordine.',
  footTips2:
    'Il buono non può essere utilizzato per acquistare valute/gettoni di gioco.',
  footTips3:
    "Ci riserviamo il diritto per l'interpretazione finale di questo evento.",
  ruleTitleText: 'Regole Evento',
  ruleTime:
    "Durata dell'Evento: 00:00 del 24 Nov. 2023 alle 23:59 del 26 Nov. 2023 (UTC)",
  bfRuleText1:
    "1. 400 punti verranno assegnati al tuo account quando accedi per la prima volta alla pagina di ricarica ufficiale durante l'evento. Puoi scambiare fino a 500 punti con buoni.",
  bfRuleText2:
    "2. Puoi scambiare i punti del Black Friday con i buoni durante l'evento.",
  bfRuleText3:
    '3. Puoi utilizzare solo 1 buono per ogni ordine. I buoni non possono essere utilizzati per acquistare valute/gettoni di gioco.',
  bfRuleText4: '4. Per le transazioni accettiamo solo le seguenti valute:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. Non è possibile cambiare la valuta una volta effettuata la transazione. I punti scambiati non possono essere rimborsati.',
  bfRuleText6: '6. I buoni del Black Friday saranno validi solo per 7 giorni.',
  bfRuleText7:
    "7. Ci riserviamo il diritto per l'interpretazione finale di questo evento.",
  thanksTip:
    "Grazie per la vostra partecipazione. Unisciti alla nostra community ufficiale per ulteriori informazioni sull'evento.",
  exchangePoints: 'Scambio',
  exchangeCode: 'Inserisci il codice di scambio.',
  enterExchangeCode: 'Inserisci il codice di scambio.',
  exchangeText: 'Scambio',
  confirmGet: 'Conferma',
  couponUsedWay:
    'Il buono può essere utilizzato solo con valute specifiche, conferma la tua valuta.',
  confirmText: 'Conferma',
  exchangeSucc: 'Scambiato',
  aboutCoins: 'Informazioni su Valute/Gettoni di gioco',
  aboutCoinsText:
    'Puoi scambiare valute/gettoni di gioco con tutti i pacchetti e privilegi ad eccezione della valuta/gettone di gioco stesso.',
  known: 'OK',
  codeText: 'Codice',
  codeInvalid: 'Codice invalido!',
  hasExchanged: 'Non puoi richiedere più codici.',
  hideText: 'Nascondi',
  //黑五的报错码
  'bf-20001': 'Accesso non effettuato',
  'bf-20002': "Errore di parametro. Prova a rientrare nell'evento.",
  'bf-20003': 'Pti insufficienti',
  'bf-20004': "Fallito! Riprova più tardi o contatta l'Assistenza Clienti.",
  'bf-20005': 'Rivendicato',
  'bf-20015': 'L’evento non è al momento disponibile',
  'bf-20016': 'L’evento è terminato.',
  bfShareText: 'Rivendica Buono 10% SCONTO Ora!',
  rightsCenterBtn: 'Centro Membro Premium',
  payBtn: 'Pagamento',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Glorioso Straordinario (Permanente)',
  '-': '-'
};
